import { API_URL } from "./helpers";

export const UI_LIST_BULK_MAX_ITEMS = 50;

export type ProductReportUiListBulkItem = {
  external_id: string;
  ui_list: string;
};

export type ProductReportUiListBulkResponse = {
  updated_count: number;
  skipped_count: number;
  errors: { external_id: string; detail: string }[];
};

export async function postProductReportsUiListBulk(
  requestApi: { post: (url: string, body: unknown) => Promise<{ data: unknown }> },
  reportType: "MISCONDUCT" | "360",
  items: ProductReportUiListBulkItem[]
): Promise<ProductReportUiListBulkResponse> {
  const response = await requestApi.post(
    `${API_URL}/product_reports/ui_list/bulk`,
    { report_type: reportType, items }
  );
  return response.data as ProductReportUiListBulkResponse;
}
